import { createElement } from 'react';

import { editBox, view } from './NumberFieldBox.less';

const setValue = (onChange, min) => e => {
  if (isNaN(e.target.value) || !e.target.value) {
    onChange(null);
  }
  if ((min && e.target.value >= min) || !min) {
    onChange(Number(e.target.value));
  }
};

const NumberFieldBox = ({ editing, input, meta, localeMessage, formValues, hintLocale, min, ...other }) =>
  editing
    ? createElement('input', {
        className: editBox,
        name: input.name,
        value: input.value,
        type: 'number',
        min: min,
        onChange: setValue(input.onChange, min),
        placeholder: hintLocale && localeMessage(hintLocale),
        ...other,
      })
    : createElement('div', { className: view }, input.value);

export default NumberFieldBox;
